import React from "react";

import { Form } from "affinityForm";
import { ExecuteButton } from "affinityForm/components/executeButton";
import { ConfirmField, InputField, RadioPickerField } from "affinityForm/fields";
import { Button, ButtonVariants } from "affinityUI/elements/button";
import { Card } from "affinityUI/elements/card";
import { Grid } from "affinityUI/elements/grid";
import { ButtonGroup, DataEntryGroup } from "affinityUI/form/components";
import type { RoleInfo } from "types/index";

export const UserForm: React.FC<{ roles: RoleInfo[]; onCancel: () => void }> = ({ roles, onCancel: handleCancel }) => {
  return (
    <Card data-testid="userinfo-form">
      <Form>
        <DataEntryGroup title="User Information" id="user-information">
          <Grid $cols={[1, 1]}>
            <InputField name="firstName">First name</InputField>
            <InputField name="lastName">Last name</InputField>
          </Grid>
          <ConfirmField name="email" confirmLabel="Confirm email">
            Email
          </ConfirmField>
        </DataEntryGroup>
        <DataEntryGroup
          title="Access"
          description="Assign access to users by selecting the permission most suited to them."
          id="access"
        >
          <RadioPickerField name="roleId">
            {roles.map((roleInfo) => (
              <RadioPickerField.Option key={roleInfo.id} value={roleInfo.id} label={roleInfo.name}>
                {roleInfo.description}
              </RadioPickerField.Option>
            ))}
          </RadioPickerField>
        </DataEntryGroup>
        <ButtonGroup>
          <Button variant={ButtonVariants.SECONDARY} onClick={handleCancel}>
            Cancel
          </Button>
          <ExecuteButton>Continue to confirmation</ExecuteButton>
        </ButtonGroup>
      </Form>
    </Card>
  );
};
